export default {"src":"/uk/_next/static/media/spot-diverse-portfolio.c6b587d5.svg","height":61,"width":60,"blurWidth":0,"blurHeight":0};